import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";
class StudentBusAssignmentStore {
  total = 0;
  studentAssignmentStore = [];
  summary = [];
  loading = false;
  datetimedrop = [];
  summary_id = [];

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      studentAssignmentStore: observable,
      summary: observable,
      loadData: action,
      loading: observable,
      datetimedrop: observable,
      summary_id: observable,

      saveMapPoints: action,
      delteMapPoints: action,
    });
  }

  async loadData({
    companyId,
    vehicleId,
    garage,
    fromVehicleLocation,
    unassignedOnly,
    offset,
    limit,
    pageNo,
    id,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      MAX_DISTANCE_KM: 13,
      garage: garage,
      fromVehicleLocation: fromVehicleLocation,
      unassignedOnly: unassignedOnly,
      offset: offset,
      limit: limit,
      page: pageNo,
      id: id,
    };

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/student_assignment/assignBus", postData);
    // var response = await postApi.getClient("").post("http://127.0.0.1:5000/student_assignment/assignBus", postData);

    this.studentAssignmentStore = response?.data?.data;

    this.studentAssignmentData = response?.data?.data.map(
      (items) => items.studentList,
    );
    this.total = response?.data?.TotalCount;
    this.summary = response?.data?.summary;
    this.loading = false;
    this.summary_id = response?.data?.summary_id;
    console.log("asdbadksa", response?.data?.summary_id);
  }

  async updateAssignVehicle(passengerData) {
    // console.log(passengerData)
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/passenger/updateAssignVehicle", passengerData);

    // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/updateAssignVehicle", passengerData);
    return response?.data;
  }

  async standardDataExcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/student_assignment/exportAssignAllVehicleExcel",
          getData,
          {
            responseType: "blob",
          },
        );

      // var response = await postApi.getClient("").post("http://127.0.0.1:5000/student_assignment/exportAssignAllVehicleExcel",getData,
      //     {
      //     responseType: "blob",
      //     }
      // );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Student Assignment list.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async routeMapexcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/student_assignment/exportAllMapVehicleExcel",
          getData,
          {
            responseType: "blob",
          },
        );

      // var response = await postApi.getClient("").post("http://127.0.0.1:5000/student_assignment/exportAllMapVehicleExcel",getData,
      //     {
      //     responseType: "blob",
      //     }
      // );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Student Route Map Assignment.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportStudentVehicleExcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/student_assignment/exportAssignVehicleExcel",
          getData,
          {
            responseType: "blob",
          },
        );

      // var response = await postApi.getClient("").post("http://127.0.0.1:5000/student_assignment/exportAssignVehicleExcel",getData,
      //     {
      //     responseType: "blob",
      //     }
      // );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Student Vehicle Assignment list.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async savepostname(postData) {
    console.log(postData);
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/student_assignment/saveAssignment", postData);

    // var response = await postApi.getClient("").post("http://127.0.0.1:3005/passenger/updateAssignVehicle", passengerData);
    return response?.data;
  }

  async datedropfilter(getData) {
    const postData = {
      companyId: getData,
    };
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/student_assignment/getAssignment", postData);

    console.log(response, "dropdown response");
    this.datetimedrop = response?.data?.data;
  }

  async saveMapPoints(postData) {
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/passenger/saveGeofencePoints", { postData });
    return response.data
  }

  async delteMapPoints(postData) {

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/passenger/deleteRouteDeviationAlert", {
        postData
      });
    return response.data
  }
}

export default StudentBusAssignmentStore;
